import React from "react";
import PropTypes from "prop-types";

const ContactInfo = ({ data }) => {
    return (
        <div className={data.classOption}>
            <i className={data.thumb}></i>{" "}
            <h4 className="text-primary">{data.title}</h4>
            <p dangerouslySetInnerHTML={{ __html: data.info }}></p>
        </div>
    );
};

ContactInfo.propTypes = {
    data: PropTypes.object,
};

export default ContactInfo;
